import React, { useEffect, useState } from 'react';
import useContextMenu from '../../../../hooks/useContextMenu';
import useOutsideClick from '../../../../helpers/utils';
import { useSchemeEditorContext } from '../../SchemeEditorProvider';
import CommonAddMenu from '../CommonAddMenu';
import { SchemeNodeTypes, SchemeObjectTypes } from 'consts/scheme.consts';

const ObjectSelectMenu = ({
  onSelect = undefined,
  onClose = undefined,
  node = undefined,
  filterMenu = false,
}) => {
  const [
    addObjectMenuOpen,
    addObjectMenuPosition,
    openAddObjectMenu,
    closeAddObjectMenu,
    addObjectMenuRef,
  ] = useContextMenu();

  const { typeSamplesList, typeSampleSourcesList } = useSchemeEditorContext();

  useOutsideClick(addObjectMenuRef, () => {
    closeAddObjectMenu();
    if (onClose) onClose();
  });

  const [addObjectMenuOptions, setAddObjectMenuOptions] = useState([
    { title: 'Тип образца', type: SchemeObjectTypes.typeSamples },
    { title: 'Тип источника образца', type: SchemeObjectTypes.typeSampleSources },
    { title: 'Хранилище', node: SchemeNodeTypes.storage },
  ]);

  useEffect(() => {
    openAddObjectMenu();
  }, []);

  useEffect(() => {
    setAddObjectMenuOptions(() =>
      [
        {
          title: 'Тип образца',
          items: filterMenu
            ? typeSamplesList.filter((item) => !node?.objects?.some((obj) => obj.id == item.value))
            : typeSamplesList,
          type: SchemeObjectTypes.typeSamples,
        },
        {
          title: 'Тип источника образца',
          items: filterMenu
            ? typeSampleSourcesList.filter(
                (item) => !node?.objects?.some((obj) => obj.id == item.value),
              )
            : typeSampleSourcesList,
          type: SchemeObjectTypes.typeSampleSources,
        },
        { title: 'Хранилище', node: SchemeNodeTypes.storage },
      ]
        .filter(
          (item) => !filterMenu || !node?.objects?.length || item.type === node?.objects[0].type,
        )
        .filter(
          (item) =>
            item.node !== SchemeNodeTypes.storage ||
            !node?.children.some((n) => n.type !== SchemeNodeTypes.qualityControl),
        ),
    );
  }, [typeSamplesList, typeSampleSourcesList]);

  const handleSelect = (e) => {
    onSelect ? onSelect(e) : undefined;

    closeAddObjectMenu();
  };

  return (
    <CommonAddMenu
      ref={addObjectMenuRef}
      title={'Выберите объект'}
      actions={addObjectMenuOptions}
      position={{ ...addObjectMenuPosition }}
      open={addObjectMenuOpen}
      onSelect={handleSelect}
    />
  );
};

export default ObjectSelectMenu;
